// Norsk (nb-NO) base for Mimin. Dette er fase A-grunnmuren: de mest synlige
// app-strengene er oversatt, resten faller tilbake til engelsk via
// mergeTranslations(englishCatalog, norwegianCrmMessages) med allowMissing.
// Full oversettelse (inkl. react-admin sin base-pakke) gjøres i fase G.
//
// Norske copy-regler: ingen tankestrek, aktiv imperativ, Stor Forbokstav på
// knapper og overskrifter.
export const norwegianCrmMessages = {
  // Overstyr de vanligste react-admin-knappene så grensesnittet er synlig norsk
  // selv før en full nb-base-pakke er på plass.
  ra: {
    action: {
      save: "Lagre",
      cancel: "Avbryt",
      delete: "Slett",
      edit: "Rediger",
      create: "Opprett",
      add: "Legg til",
      remove: "Fjern",
      back: "Tilbake",
      confirm: "Bekreft",
      search: "Søk",
      show: "Vis",
      list: "Liste",
      refresh: "Oppdater",
      close: "Lukk",
      open: "Åpne",
      clear_input_value: "Tøm",
      select_all: "Velg alle",
      unselect: "Fjern valg",
    },
    navigation: {
      no_results: "Ingen treff",
      page_rows_per_page: "Rader per side:",
    },
    auth: {
      sign_in: "Logg inn",
      sign_out: "Logg ut",
      email: "E-post",
      password: "Passord",
    },
    boolean: {
      true: "Ja",
      false: "Nei",
    },
    message: {
      loading: "Laster inn",
      yes: "Ja",
      no: "Nei",
      are_you_sure: "Er du sikker?",
    },
    page: {
      dashboard: "Oversikt",
    },
  },
  resources: {
    companies: {
      name: "Kunde |||| Kunder",
      forcedCaseName: "Kunde",
      fields: {
        name: "Kundenavn",
        website: "Nettside",
        linkedin_url: "LinkedIn-URL",
        phone_number: "Telefonnummer",
        email: "E-post",
        created_at: "Opprettet",
        nb_contacts: "Antall kontakter",
        revenue: "Omsetning",
        sector: "Bransje",
        size: "Størrelse",
        tax_identifier: "Organisasjonsnummer",
        address: "Adresse",
        city: "Poststed",
        zipcode: "Postnummer",
        state_abbr: "Fylke",
        country: "Land",
        description: "Beskrivelse",
        context_links: "Lenker",
        sales_id: "Kundeansvarlig",
        has_google_review: "Har gitt Google-omtale",
        ask_for_review: "Spør om Google-omtale",
        review_asked_at: "Sist spurt om omtale",
      },
      empty: {
        title: "Ingen kunder funnet",
        description: "Kundelisten din er tom.",
      },
      field_categories: {
        contact: "Kontakt",
        additional_info: "Tilleggsinformasjon",
        address: "Adresse",
        context: "Kontekst",
      },
      action: {
        create: "Opprett kunde",
        edit: "Rediger kunde",
        new: "Ny kunde",
        show: "Vis kunde",
      },
      added_on: "Lagt til %{date}",
      followed_by: "Fulgt av %{name}",
      followed_by_you: "Fulgt av deg",
      no_contacts: "Ingen kontakt",
      nb_contacts: "%{smart_count} kontakt |||| %{smart_count} kontakter",
      nb_deals: "%{smart_count} mulighet |||| %{smart_count} muligheter",
      sizes: {
        one_employee: "1 ansatt",
        two_to_nine_employees: "2-9 ansatte",
        ten_to_forty_nine_employees: "10-49 ansatte",
        fifty_to_two_hundred_forty_nine_employees: "50-249 ansatte",
        two_hundred_fifty_or_more_employees: "250 eller flere ansatte",
      },
      autocomplete: {
        create_error: "Noe gikk galt under opprettelse av kunden",
        create_item: "Opprett %{item}",
        create_label: "Begynn å skrive for å opprette en ny kunde",
      },
      filters: {
        only_mine: "Bare kunder jeg er ansvarlig for",
      },
    },
    contacts: {
      name: "Kontakt |||| Kontakter",
      forcedCaseName: "Kontakt",
      fields: {
        first_name: "Fornavn",
        last_name: "Etternavn",
        last_seen: "Sist sett",
        title: "Stilling",
        company_id: "Kunde",
        email_jsonb: "E-postadresser",
        email: "E-post",
        phone_jsonb: "Telefonnumre",
        phone_number: "Telefonnummer",
        linkedin_url: "LinkedIn-URL",
        background: "Bakgrunn (bio, hvordan dere møttes osv.)",
        has_newsletter: "Mottar nyhetsbrev",
        sales_id: "Kundeansvarlig",
      },
      action: {
        add: "Legg til kontakt",
        add_first: "Legg til din første kontakt",
        create: "Opprett kontakt",
        edit: "Rediger kontakt",
        new: "Ny kontakt",
        show: "Vis kontakt",
      },
      empty: {
        title: "Ingen kontakter funnet",
        description: "Kontaktlisten din er tom.",
      },
    },
    deals: {
      name: "Mulighet |||| Muligheter",
      fields: {
        name: "Navn",
        description: "Beskrivelse",
        company_id: "Kunde",
        contact_ids: "Kontakter",
        category: "Kategori",
        amount: "Budsjett",
        expected_closing_date: "Forventet sluttdato",
        stage: "Stadium",
        next_step: "Neste steg",
        next_step_date: "Neste steg innen",
        sales_id: "Ansvarlig",
        loss_reason: "Tapsårsak",
        renewal_date: "Fornyelsesdato",
      },
      loss_reason: {
        pris_budsjett: "Pris/budsjett",
        timing: "Timing – ikke nå",
        valgte_konkurrent: "Valgte konkurrent",
        ingen_respons: "Ingen respons",
        ikke_rett_match: "Ikke rett match",
        intern_losning: "Intern løsning / gjør det selv",
        lagt_ned: "Prosjektet ble lagt ned",
        annet: "Annet",
        annet_migrert: "Annet (migrert)",
      },
      action: {
        back_to_deal: "Tilbake til muligheten",
        create: "Opprett mulighet",
        create_project: "Opprett prosjekt",
        edit: "Rediger mulighet",
        new: "Ny mulighet",
        show: "Vis mulighet",
      },
      field_categories: {
        misc: "Diverse",
      },
      archived: {
        action: "Arkiver",
        error: "Feil: muligheten ble ikke arkivert",
        list_title: "Arkiverte muligheter",
        success: "Mulighet arkivert",
        title: "Arkivert mulighet",
        view: "Vis arkiverte muligheter",
      },
      inputs: {
        linked_to: "Knyttet til",
      },
      filters: {
        only_mine: "Bare muligheter jeg er ansvarlig for",
      },
      unarchived: {
        action: "Send tilbake til tavla",
        error: "Feil: muligheten ble ikke gjenopprettet",
        success: "Mulighet gjenopprettet",
      },
      updated: "Mulighet oppdatert",
      empty: {
        before_create: "før du oppretter en mulighet.",
        description: "Mulighetslisten din er tom.",
        title: "Ingen muligheter funnet",
      },
      invalid_date: "Ugyldig dato",
    },
    projects: {
      name: "Prosjekt |||| Prosjekter",
      forcedCaseName: "Prosjekt",
      fields: {
        name: "Prosjektnavn",
        description: "Beskrivelse",
        company_id: "Bedrift",
        sales_id: "Prosjektansvarlig",
        created_at: "Opprettet",
        archived_at: "Arkivert",
      },
      action: {
        create: "Opprett prosjekt",
        edit: "Rediger prosjekt",
        new: "Nytt prosjekt",
        show: "Vis prosjekt",
      },
      views: {
        board: "Tavle",
        list: "Liste",
        calendar: "Kalender",
      },
      empty: {
        title: "Ingen prosjekter funnet",
        description: "Prosjektlisten din er tom.",
      },
    },
    work_items: {
      name: "Oppgave |||| Oppgaver",
      forcedCaseName: "Oppgave",
      fields: {
        title: "Tittel",
        description: "Beskrivelse",
        attachments: "Vedlegg",
        company_id: "Kunde",
        project_id: "Prosjekt",
        section_id: "Status",
        parent_task_id: "Hovedoppgave",
        assignee_id: "Ansvarlig",
        priority: "Prioritet",
        due_date: "Frist",
        completed_at: "Fullført",
        created_at: "Opprettet",
        status: "Status",
      },
      action: {
        create: "Opprett oppgave",
        edit: "Rediger oppgave",
        new: "Ny oppgave",
        show: "Vis oppgave",
      },
      quick: {
        description:
          "Opprett en oppgave. Flere felt finner du i det fulle skjemaet.",
        more_fields: "Flere felt",
      },
      priority: {
        low: "Lav",
        normal: "Normal",
        high: "Høy",
        urgent: "Haster",
      },
      status: {
        open: "Åpne",
        done: "Fullførte",
        open_one: "Åpen",
        done_one: "Fullført",
      },
      empty: {
        title: "Ingen oppgaver funnet",
        description: "Oppgavelisten din er tom.",
      },
      no_project: "Ingen – ligger på kunden",
      notification: {
        time_not_saved:
          "Oppgaven ble opprettet, men den registrerte tiden ble ikke lagret.",
      },
    },
    sections: {
      name: "Status |||| Statuser",
      none: "Uten status",
      is_done: "Fullfører oppgaven",
      is_done_help: "Oppgaver som får denne statusen regnes som fullført",
      empty: "Dette prosjektet har ingen statuser ennå.",
      add: "Ny status",
      global: "Statuser for oppgaver på kundenivå",
    },
    field_defs: {
      name: "Egendefinert felt |||| Egendefinerte felt",
      fields: {
        name: "Feltnavn",
        entity: "Tilhører",
        type: "Type",
        options: "Valg",
        hidden: "Skjult",
      },
      action: {
        create: "Opprett felt",
        edit: "Rediger felt",
        new: "Nytt felt",
      },
      empty: {
        title: "Ingen egendefinerte felt",
        description:
          "Opprett felt for kunder, prosjekter, oppgaver eller produkter.",
      },
    },
    products: {
      name: "Produkt |||| Produkter",
      fields: {
        product_number: "Produktnr",
        name: "Navn",
        description: "Beskrivelse",
        unit: "Enhet",
        purchase_price: "Innkjøpspris eks. mva",
        sales_price: "Utsalgspris eks. mva",
        sales_price_incl_vat: "Utsalgspris inkl. mva",
        vat_rate: "Mva-sats (%)",
        currency: "Valuta",
        is_active: "Aktiv",
        image: "Produktbilde",
      },
      action: {
        create: "Opprett produkt",
        edit: "Rediger produkt",
        new: "Nytt produkt",
      },
      empty: {
        title: "Ingen produkter",
        description: "Opprett produkter og tjenester for kundekalkyle.",
      },
      status: {
        active: "Aktiv",
        inactive: "Inaktiv",
      },
    },
    company_products: {
      name: "Kundeprodukt |||| Kundeprodukter",
      fields: {
        product_id: "Produkt",
        quantity: "Antall",
        price: "Avtalt pris eks. mva",
        cost: "Kostpris",
        billing_interval: "Fakturering",
        start_date: "Startdato",
        end_date: "Sluttdato",
        renewal_date: "Fornyes",
        last_maintained_on: "Siste vedlikehold",
        last_invoiced_on: "Sist fakturert",
        last_invoice_ref: "Faktura",
        note: "Notat",
      },
    },
    // Atomics opprinnelige tasks er kontaktpåminnelser. Mimins PM-oppgaver bor i
    // work_items («Oppgaver»), så disse omtales som «Påminnelser».
    tasks: {
      name: "Påminnelse |||| Påminnelser",
    },
    tags: {
      name: "Etikett |||| Etiketter",
    },
    sales: {
      name: "Bruker |||| Brukere",
    },
  },
  crm: {
    agreements: {
      title: "Løpende avtaler",
      description:
        "Alle kunders løpende produkter og tjenester. Fornyelse, siste vedlikehold og egne felt legger du inn på avtalen.",
      kpi: {
        active: "Aktive avtaler",
        customers: "Kunder",
        renewal: "Fornyes innen %{days} dager",
        maintenance: "Ikke vedlikeholdt på %{months} mnd",
      },
      search: "Søk på kunde, produkt eller felt",
      show: {
        all: "Alle",
        renewal: "Fornyes snart",
        maintenance: "Trenger vedlikehold",
      },
      columns: {
        company: "Kunde",
        amount: "Pris",
        interval: "Periode",
      },
      maintained: "Vedlikehold registrert i dag",
      mark_maintained: "Vedlikehold utført i dag",
      today: "I dag",
      intervals: {
        one_time: "Engangs",
        monthly: "Månedlig",
        quarterly: "Kvartalsvis",
        semiannual: "Halvårlig",
        yearly: "Årlig",
      },
      nav: "Avtaler",
    },
    quotes: {
      title: "Tilbud",
      needs_lines: "Legg inn produktlinjer først.",
      create: "Lag tilbud",
      empty: "Ingen tilbud ennå.",
      viewed: "Åpnet av kunden",
      expired: "Utløpt",
      link_copied: "Lenken til tilbudet er kopiert",
      sent_done:
        "Tilbudet er sendt. Kopier lenken eller last ned PDF til kunden.",
      dialog_title: "Tilbud #%{number}",
      draft_hint:
        "Utkastet ser bare du. Kunden ser tilbudet når du markerer det som sendt.",
      viewed_at: "Åpnet av kunden %{date}.",
      locked_hint:
        "Sendte tilbud er låst. Ta det tilbake til utkast for å endre det.",
      fields: {
        title: "Tittel",
        intro: "Innledning",
        lines: "Linjer",
        valid_until: "Gyldig til",
        terms: "Vilkår",
      },
      lines_refreshed: "Linjene er hentet fra produktlinjene på nytt",
      refresh_lines: "Hent produktlinjene på nytt",
      totals: {
        first_year: "Første år",
        one_time: "Engangs",
        monthly: "Per måned",
      },
      delete: "Slett utkast",
      edit: "Rediger",
      preview: "Forhåndsvis",
      copy_link: "Kopier lenke",
      open_pdf: "PDF",
      saved: "Tilbudet er lagret",
      mark_sent: "Marker som sendt",
      back_to_draft: "Tilbake til utkast",
      mark_declined: "Avslått",
      mark_accepted: "Akseptert",
      back_to_sent: "Tilbake til sendt",
      document: {
        label: "Tilbud",
        date: "Dato",
        valid_until: "Gyldig til",
        to: "Til",
        description: "Beskrivelse",
        quantity: "Antall",
        unit_price: "Pris",
        interval: "Periode",
        amount: "Sum",
        vat: "Alle priser er oppgitt eks. mva.",
        terms: "Vilkår",
        contact: "Spørsmål om tilbudet? Ta kontakt med",
      },
      public: {
        loading: "Henter tilbudet …",
        missing_title: "Fant ikke tilbudet",
        missing:
          "Lenken er feil, eller tilbudet er trukket tilbake. Ta kontakt med den som sendte deg lenken.",
        print: "Last ned som PDF",
      },
      status: {
        draft: "Utkast",
        sent: "Sendt",
        accepted: "Akseptert",
        declined: "Avslått",
      },
    },
    action: {
      reset_password: "Tilbakestill passord",
    },
    auth: {
      first_name: "Fornavn",
      last_name: "Etternavn",
      confirm_password: "Bekreft passord",
      confirmation_required:
        "Følg lenken vi nettopp sendte deg på e-post for å bekrefte kontoen din.",
      recovery_email_sent:
        "Er du registrert bruker, får du snart en e-post for å tilbakestille passordet.",
      link_expired:
        "Lenken er utløpt eller allerede brukt. Be om en ny for å sette nytt passord.",
      or: "eller",
      sign_in_failed: "Innlogging mislyktes.",
      sign_in_google_workspace: "Logg inn med Google Workspace",
      sign_in_subtitle: "Logg inn for å fortsette til %{title}",
      signing_in: "Logger inn …",
      signup: {
        create_account: "Opprett konto",
        create_first_user:
          "Opprett den første brukerkontoen for å fullføre oppsettet.",
        creating: "Oppretter...",
        initial_user_created: "Første bruker opprettet",
      },
      welcome_back: "Velkommen tilbake",
      welcome_title: "Velkommen til Mimin",
    },
    common: {
      activity: "Aktivitet",
      added: "la til",
      details: "Detaljer",
      last_activity_with_date: "siste aktivitet %{date}",
      load_more: "Last inn flere",
      misc: "Diverse",
      past: "Tidligere",
      read_more: "Les mer",
      retry: "Prøv igjen",
      show_less: "Vis mindre",
      copied: "Kopiert!",
      copy: "Kopier",
      loading: "Laster inn...",
      me: "Meg",
      task_count: "%{smart_count} oppgave |||| %{smart_count} oppgaver",
    },
    changelog: {
      title: "Endringslogg",
    },
    tutorial: {
      title: "Veiledning",
    },
    quick_create: {
      new: "Ny",
      company_description:
        "Registrer kunden med grunnleggende informasjon. Flere detaljer kan fylles ut på kundekortet senere.",
      contact_description:
        "Registrer kontakten med grunnleggende informasjon. Flere detaljer kan fylles ut på kontaktkortet senere.",
    },
    activity: {
      added_company: "%{name} la til kunde",
      you_added_company: "Du la til kunde",
      added_contact: "%{name} la til",
      you_added_contact: "Du la til",
      added_note: "%{name} la til et notat om",
      you_added_note: "Du la til et notat om",
      added_note_about_deal: "%{name} la til et notat om muligheten",
      you_added_note_about_deal: "Du la til et notat om muligheten",
      added_deal: "%{name} la til muligheten",
      you_added_deal: "Du la til muligheten",
      at_company: "hos",
      to: "til",
      load_more: "Last inn mer aktivitet",
    },
    csv_import: {
      file: "CSV-fil",
      start: "Start import",
      stop: "Stopp import",
      another: "Importer en fil til",
      reading: "Leser fila …",
      running: "Importen kjører. Ikke lukk fanen.",
      cancelled:
        "Importen ble stoppet. Radene som allerede var lagret, er beholdt.",
      read_error: "Kunne ikke lese fila: %{message}",
      rows_done: "%{done} av %{total} rader behandlet",
      created: "Opprettet",
      updated: "Oppdatert",
      skipped: "Hoppet over",
      failed: "Feilet",
      problems: "Rader som ikke ble importert",
      line: "Linje %{line}",
      more_problems:
        "… og %{smart_count} rad til |||| … og %{smart_count} rader til",
      unknown_error: "Ukjent feil",
      reasons: {
        no_name: "Mangler navn",
        no_name_or_email: "Mangler både navn og e-post",
        invalid_email: "Ugyldig e-postadresse: %{email}",
        duplicate_email: "Finnes allerede en kontakt med %{email}",
        duplicate_customer_number:
          "Kundenummer %{number} står flere ganger i fila",
        archived: "%{name} er arkivert og blir ikke endret",
      },
    },
    dashboard: {
      deals_chart: "Forventet omsetning fra muligheter",
      deals_pipeline: "Pipeline",
      latest_activity: "Siste aktivitet",
      latest_activity_error: "Klarte ikke å laste siste aktivitet",
      latest_notes: "Mine siste notater",
      latest_notes_added_ago: "lagt til %{timeAgo}",
      stepper: {
        install: "Installer Mimin",
        progress: "%{step}/3 ferdig",
        whats_next: "Hva nå?",
      },
      upcoming_tasks: "Kommende oppgaver",
    },
    header: {},
    image_editor: {
      change: "Endre",
      drop_hint: "Slipp en fil for å laste opp, eller klikk for å velge.",
      editable_content: "Redigerbart innhold",
      title: "Last opp og endre størrelse på bilde",
      update_image: "Oppdater bilde",
    },
    settings: {
      about: "Om",
      companies: {
        sectors: "Bransjer",
      },
      dark_mode_logo: "Logo for mørk modus",
      deals: {
        categories: "Kategorier",
        currency: "Valuta",
        pipeline_help: "Velg hvilke stadier som skal telle som pipeline.",
        pipeline_statuses: "Pipeline-statuser",
        stages: "Stadier",
      },
      light_mode_logo: "Logo for lys modus",
      notes: {
        statuses: "Statuser",
      },
      reset_defaults: "Tilbakestill til standard",
      save_error: "Klarte ikke å lagre konfigurasjonen",
      saved: "Konfigurasjonen er lagret",
      saving: "Lagrer...",
      tasks: {
        types: "Typer",
      },
      preferences: "Innstillinger",
      title: "Innstillinger",
      app_title: "Apptittel",
      groups: {
        generelt: "Generelt",
        kunder: "Kunder og prosjekter",
        salg: "Salg og pipeline",
        leads: "Leads og inntak",
        epost: "E-post og tekster",
        fakturering: "Fakturering",
      },
      sections: {
        branding: "Merkevare",
        prospecting: "Prospektering",
        billing: "Fakturering",
      },
      prospecting: {
        fit_help:
          "Hvem som passer som kunde. Dette justerer rekkefølgen i prospektlista med én gang — ingen ny skanning trengs. Det endrer ikke hva som er funnet på nettstedene, bare hvilke funn som prioriteres.",
        fit_neutral:
          "Alt du ikke fører opp er nøytralt, ikke uønsket. Skal noe aktivt nedprioriteres, må det stå her med vekten «Unngå».",
        sectors: "Bransjer",
        sectors_help:
          "Næringskode som tall, slik den står i prospektfilteret. To siffer treffer hele bransjen («47» = varehandel); flere siffer treffer smalere og går foran («47.11»).",
        municipalities: "Foretrukne kommuner",
        municipalities_help:
          "Kommunenummer, skilt med komma — for eksempel «0301, 3201, 3203». Oppførte kommuner løftes litt (×1,10). De øvrige straffes ikke.",
        size: "Størrelse",
        size_help:
          "Antall ansatte. Under det første tallet er kjernemålgruppa (full vekt). Derfra dempes prospektet gradvis: ×0,85, så ×0,60 fra neste grense og ×0,30 fra den siste. Store selskaper siles ikke bort — de havner nederst.",
        core_under: "Kjernemålgruppe under",
        large_from: "Stor fra",
        huge_from: "Svært stor fra",
        platforms: "Plattformer",
        platforms_help:
          "Plattformen prospektets nettsted kjører på i dag. Ta med de du helst vil overta.",
      },
      validation: {
        duplicate: "Duplikat %{display_name}: %{items}",
        in_use:
          "Kan ikke fjerne %{display_name} som fortsatt brukes av muligheter: %{items}",
        validating: "Validerer…",
        entities: {
          categories: "kategorier",
          stages: "stadier",
        },
      },
    },
    theme: {
      dark: "Mørk",
      label: "Tema",
      light: "Lys",
      system: "System",
      toggle: "Bytt tema",
    },
    sidebar: {
      label: "Sidemeny",
      mobile_description: "Viser sidemenyen på mobil.",
      toggle: "Veksle sidemeny",
    },
    language: "Språk",
    navigation: {
      label: "Mimin-navigasjon",
    },
    profile: {
      inbound: {
        description:
          "Du kan sende e-post til serverens innkommende adresse, f.eks. ved å legge den i %{field}-feltet. Mimin behandler e-postene og legger notater på de tilhørende kontaktene.",
        title: "Innkommende e-post",
      },
      password: {
        change: "Bytt passord",
      },
      password_reset_sent:
        "En e-post for å tilbakestille passordet er sendt til adressen din",
      record_not_found: "Fant ikke posten",
      title: "Profil",
      updated: "Profilen din er oppdatert",
      update_error: "Noe gikk galt. Prøv igjen",
    },
    validation: {
      invalid_url: "Må være en gyldig URL",
      invalid_linkedin_url: "URL-en må være fra linkedin.com",
    },
  },
};
